import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AIDirectLineTokenService {

  private FLOW_URL = environment.aiFlowUrl;

  constructor(private http: HttpClient) {}

  async getToken(): Promise<string> {
    const result: any = await firstValueFrom(
      this.http.post(this.FLOW_URL, {})
    );

    return result?.token;
  }

  
}
